import { Dispatch, SetStateAction } from "react";
import {
	TrainingEfficiencyOptions,
	TrainingFrequencyOptions,
} from "../../../hooks/useEstimateWasteCalculator";
import Fieldset from "../Fieldset/Fieldset";
import Typography from "../Typography/Typography";
import "./Lever.scss";

export type LeverProps = {
	keyName: string;
	legend: string;
	options: (TrainingEfficiencyOptions | TrainingFrequencyOptions)[];
	suffix: string;
	onChange: Dispatch<
		SetStateAction<TrainingEfficiencyOptions | TrainingFrequencyOptions>
	>;
	value?: TrainingEfficiencyOptions | TrainingFrequencyOptions;
};
const Lever = ({
	keyName,
	legend,
	options,
	suffix,
	onChange,
	value,
}: LeverProps) => {
	const selected = value ?? options[0].toString();

	const handleChange = (
		newValue: TrainingEfficiencyOptions | TrainingFrequencyOptions,
	) => {
		onChange(newValue);
	};

	return (
		<Fieldset className="lever">
			<Typography as="legend" className="lever__title">
				{legend}
			</Typography>
			<div className="lever__group row">
				<div className="lever__options column">
					{options.map((option) => (
						<div
							role="group"
							className="lever__option row"
							key={`${keyName}-${option}`}>
							<input
								type="radio"
								id={`${keyName}-${option}`}
								name={keyName}
								value={option.toString()}
								checked={option.toString() === selected}
								onChange={() => handleChange(option)}
							/>
							<label htmlFor={`${keyName}-${option}`}>{option}</label>
							<span className="lever__option-handle"></span>
						</div>
					))}
				</div>
				{suffix && (
					<Typography as="span" className="lever__suffix">
						{suffix}
					</Typography>
				)}
			</div>
		</Fieldset>
	);
};

export default Lever;
